import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, Download, Calendar, TrendingUp, Users, DollarSign, Activity } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
export function AdminReports() {
  const navigate = useNavigate();
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');
  const reports = [{
    id: 1,
    title: 'Laporan Keanggotaan Bulanan',
    description: 'Statistik keanggotaan dan pertumbuhan anggota',
    period: 'Januari 2025',
    type: 'membership',
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light',
    size: '2.5 MB',
    generated: '1 Jan 2025'
  }, {
    id: 2,
    title: 'Laporan Keuangan Bulanan',
    description: 'Pendapatan, pengeluaran, dan cash flow',
    period: 'Januari 2025',
    type: 'financial',
    icon: DollarSign,
    color: 'text-success',
    bgColor: 'bg-success-light',
    size: '3.8 MB',
    generated: '1 Jan 2025'
  }, {
    id: 3,
    title: 'Laporan Acara & Pelatihan',
    description: 'Statistik acara, peserta, dan feedback',
    period: 'Januari 2025',
    type: 'events',
    icon: Calendar,
    color: 'text-warning',
    bgColor: 'bg-warning-light',
    size: '1.9 MB',
    generated: '1 Jan 2025'
  }, {
    id: 4,
    title: 'Laporan Aktivitas Chapter',
    description: 'Aktivitas dan kinerja semua chapter',
    period: 'Januari 2025',
    type: 'chapter',
    icon: Activity,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100',
    size: '2.1 MB',
    generated: '1 Jan 2025'
  }];
  const stats = [{
    label: 'Total Laporan',
    value: '48',
    icon: FileText,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Bulan Ini',
    value: '4',
    icon: Calendar,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Pertumbuhan',
    value: '+12%',
    icon: TrendingUp,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }];
  const handleDownload = (reportId: number) => {
    alert(`Mengunduh laporan #${reportId}...`);
  };
  const handleGenerate = () => {
    alert('Membuat laporan baru...');
  };
  return <div className="min-h-screen bg-white" data-id="element-687">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-688">
        {/* Header */}
        <div className="mb-8" data-id="element-689">
          <Button variant="ghost" onClick={() => navigate('/admin/dashboard')} className="mb-4" data-id="element-690">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-691" />
            Kembali ke Dasbor
          </Button>
          <div className="flex justify-between items-start" data-id="element-692">
            <div data-id="element-693">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-694">
                Laporan Sistem
              </h1>
              <p className="text-neutral-600" data-id="element-695">
                Akses dan unduh berbagai laporan sistem
              </p>
            </div>
            <Button onClick={handleGenerate} data-id="element-696">
              <FileText className="w-4 h-4 mr-2" data-id="element-697" />
              Buat Laporan Baru
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-698">
          {stats.map((stat, i) => <Card key={i} data-id="element-699">
              <CardContent className="p-6" data-id="element-700">
                <div className="flex items-center gap-4" data-id="element-701">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-702">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-703" />
                  </div>
                  <div data-id="element-704">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-705">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-706">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Period Filter */}
        <div className="mb-6" data-id="element-707">
          <div className="flex gap-2" data-id="element-708">
            <Button variant={selectedPeriod === 'daily' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('daily')} data-id="element-709">
              Harian
            </Button>
            <Button variant={selectedPeriod === 'weekly' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('weekly')} data-id="element-710">
              Mingguan
            </Button>
            <Button variant={selectedPeriod === 'monthly' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('monthly')} data-id="element-711">
              Bulanan
            </Button>
            <Button variant={selectedPeriod === 'yearly' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('yearly')} data-id="element-712">
              Tahunan
            </Button>
          </div>
        </div>

        {/* Reports Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-713">
          {reports.map(report => <Card key={report.id} className="hover:shadow-md transition-all" data-id="element-714">
              <CardHeader data-id="element-715">
                <div className="flex items-start justify-between" data-id="element-716">
                  <div className={`p-3 rounded-lg ${report.bgColor}`} data-id="element-717">
                    <report.icon className={`w-6 h-6 ${report.color}`} data-id="element-718" />
                  </div>
                  <Badge variant="default" className="text-xs" data-id="element-719">
                    {report.period}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-720">
                <div data-id="element-721">
                  <h3 className="text-lg font-semibold text-neutral-900 mb-1" data-id="element-722">
                    {report.title}
                  </h3>
                  <p className="text-sm text-neutral-600" data-id="element-723">
                    {report.description}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-724">
                  <div data-id="element-725">
                    <p className="text-neutral-500 mb-1" data-id="element-726">Ukuran File</p>
                    <p className="font-medium text-neutral-900" data-id="element-727">
                      {report.size}
                    </p>
                  </div>
                  <div data-id="element-728">
                    <p className="text-neutral-500 mb-1" data-id="element-729">Dibuat</p>
                    <p className="font-medium text-neutral-900" data-id="element-730">
                      {report.generated}
                    </p>
                  </div>
                </div>

                <div className="flex gap-2 pt-2" data-id="element-731">
                  <Button variant="primary" size="sm" className="flex-1" onClick={() => handleDownload(report.id)} data-id="element-732">
                    <Download className="w-4 h-4 mr-2" data-id="element-733" />
                    Unduh
                  </Button>
                  <Button variant="secondary" size="sm" onClick={() => navigate(`/admin/reports/${report.id}`)} data-id="element-734">
                    Lihat
                  </Button>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </div>;
}